(() => {

    // 点击按钮调用judge评论插件的写评论按钮
    const judgeHeaderButton = document.querySelector('.judge-header__button');
    judgeHeaderButton.addEventListener('click', () => {
        document.querySelector('.jdgm-write-rev-link').click();
    });
    // 点击按钮调用judge评论插件的写评论按钮
    const judgeHeaderSubtitleButton = document.querySelector('.judge-header__subtitle-text');
    judgeHeaderSubtitleButton.addEventListener('click', () => {
        document.querySelector('.jdgm-write-rev-link').click();
    });

    // 判断是否有评论，如果有则显示头部2，如果没有则显示头部1
    let reviewsChildren = document.querySelector('.jdgm-rev-widg__reviews').children;
    if (reviewsChildren && reviewsChildren.length) {
        document.querySelector('.judge-header__content').classList.add('hidden');
    } else {
        document.querySelector('.judge-header__content-2').classList.add('hidden');
    }


})();